import { render } from "./DataChangeList.vue?vue&type=template&id=58367ad2&scoped=true"
import script from "./DataChangeList.vue?vue&type=script&lang=js"
export * from "./DataChangeList.vue?vue&type=script&lang=js"

import "./DataChangeList.vue?vue&type=style&index=0&id=58367ad2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58367ad2"]])

export default __exports__